// extracted by mini-css-extract-plugin
export default {"main":"HsqGd","icon":"fXkRA"};